import type React from 'react';
import Container from 'app/shared/core/Container';
import HdpContentWrapper from 'app/shared/modules/hdp/HdpContentWrapper';
import type { ListingDetails } from 'app/types/listingDetails.type';
import { StyledListingRestrictionTag, StyledListingTagWrapper } from './HdpSummary.styles';

interface HdpSummaryListingTagsProps {
  listing: ListingDetails;
}

const HdpSummaryListingTags: React.FC<HdpSummaryListingTagsProps> = ({ listing }) => {
  const { building, contact, details, listingType } = listing;
  const restrictionsArray: string[] = [];
  const isIncomeRestricted = !building && contact?.restricted;
  const isStudentHousing = details?.studentHousing;
  const isSeniorHousing = details?.seniorHousing;
  const isRoom = listingType === 'room';
  const isSublet = listingType === 'sublet';
  const isFurnished = details?.furnished;

  const hasRestriction = isIncomeRestricted || isSeniorHousing || isStudentHousing || isRoom || isSublet || isFurnished;

  if (!hasRestriction) {
    return null;
  }

  if (isRoom) {
    restrictionsArray.push('Room for rent');
  }
  if (isSublet) {
    restrictionsArray.push('Sublet');
  }

  if (isFurnished) {
    restrictionsArray.push('Furnished');
  }

  if (isIncomeRestricted) {
    restrictionsArray.push('Income restricted');
  }

  if (isSeniorHousing) {
    restrictionsArray.push('Senior housing');
  }

  if (isStudentHousing) {
    restrictionsArray.push('Student housing');
  }

  return (
    <div className="HdpSummaryListingTags">
      <StyledListingTagWrapper>
        <HdpContentWrapper fullContent active>
          <Container>
            <div>
              {restrictionsArray.map((item) => (
                <StyledListingRestrictionTag key={item}>{item}</StyledListingRestrictionTag>
              ))}
            </div>
          </Container>
        </HdpContentWrapper>
      </StyledListingTagWrapper>
    </div>
  );
};

export default HdpSummaryListingTags;
